import { isString } from "lodash";
import * as Yup from "yup";
import { isValidPhoneNumber } from "libphonenumber-js";

export const initPhone = async () => {
  Yup.addMethod(Yup.string, "isPhone", function (errorMessage) {
    return this.test("test-phone", errorMessage, function (value) {
      const { path, createError } = this;
      // return isValidNumber(`+91${value}`, 'IN')
      //   ? true
      //   : createError({path, message: errorMessage});
      return isValidPhoneNumber(value, "IN")
        ? true
        : createError({ path, message: errorMessage });
    });
  });
};

// export const checkRomeolane = (endpoint) => {
//   return isString(endpoint) && endpoint.includes("romeolane");
// };

export const MULTI_STORE_ENDPOINTS = ["romeolane", "caha", "skiptheq", "localpubpassport", "skiptheqpassport","charliecafe"];

export const checkMultiStore = (endpoint) => {
  return isString(endpoint) && MULTI_STORE_ENDPOINTS.includes(endpoint);
};

/**
 * Resolve API subdomain synchronously so the first paint never uses a stale default.
 * Production: first host label (e.g. dogandcrook.skiptheq.app → dogandcrook).
 * Development: REACT_APP_ENDPOINT, else "skiptheq".
 */
export const resolveEndpoint = () => {
  const isDev =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development";

  if (isDev) {
    return process.env.REACT_APP_ENDPOINT || "skiptheq";
  }

  if (typeof window === "undefined") {
    return "skiptheq";
  }

  const parts = window.location.host.split(".");
  if (parts.length >= 3 && parts[0]) {
    return parts[0];
  }

  return "skiptheq";
};

export const IS_OTP_ENABLED = false;

/**
 * Mobile SMS OTP when otp_enable is true / 1 / "1" (or missing).
 * Email OTP when otp_enable is false / 0 / "0".
 * Note: string "0" is truthy in JS — always use this helper, not raw boolean checks.
 */
export const isMobileOtpEnabled = (otpEnable) => {
  if (otpEnable === false || otpEnable === 0 || otpEnable === "0") {
    return false;
  }
  return true;
};

/**
 * Get config value by key from appConfigs array
 * @param {Array} configs - Array of config objects from Redux state
 * @param {String} item - Config key to look for
 * @param {String} key - Property to return (default: 'body')
 * @returns {String} Config value or empty string
 */
export const getConfigText = (configs, item, key = 'body') => {
  let str = '';
  if (configs && configs.length) {
    configs.forEach((i) => {
      if (i.item === item) {
        str = i[key];
      }
    });
    return str;
  }
  return str;
};

const FALLBACK_COUNTRY_CODE = "IN";

/**
 * Resolve ISO country code for phone inputs from app configs.
 * @param {Array} configs - appConfigs from Redux
 * @param {string} fallback - fallback ISO code (default: IN)
 * @returns {string} 2-letter country code for react-phone-number-input
 */
export const getDefaultCountryCode = (configs, fallback = FALLBACK_COUNTRY_CODE) => {
  const raw = getConfigText(configs, "default_country_code");
  if (!raw) return fallback;

  const code = String(raw).trim().toUpperCase();
  return /^[A-Z]{2}$/.test(code) ? code : fallback;
};

// export const slugify = (str) => {
//   str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
//   str = str.toLowerCase(); // convert string to lowercase
//   str = str.replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
//            .replace(/\s+/g, '-') // replace spaces with hyphens
//            .replace(/-+/g, '-'); // remove consecutive hyphens
//   return str;
// }
